var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClipboardList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10 .833c1.088 0 2.014.696 2.358 1.667H15.5a2 2 0 0 1 2 2v12.667a2 2 0 0 1-2 2h-11a2 2 0 0 1-2-2V4.5a2 2 0 0 1 2-2h3.142A2.501 2.501 0 0 1 10 .833zm-4.167 12.5a.833.833 0 1 0 0 1.667.833.833 0 0 0 0-1.667zm8.334 0h-5a.833.833 0 0 0-.105 1.66l.105.007h5a.833.833 0 1 0 0-1.667zM5.833 10a.833.833 0 1 0 0 1.667.833.833 0 0 0 0-1.667zm8.334 0h-5a.833.833 0 0 0-.105 1.66l.105.007h5a.833.833 0 0 0 0-1.667zm0-3.333h-5a.833.833 0 0 0-.105 1.66l.105.006h5a.833.833 0 1 0 0-1.666zm-8.334 0a.833.833 0 1 0 0 1.666.833.833 0 0 0 0-1.666zM10 2.5a.833.833 0 1 0 0 1.667.833.833 0 0 0 0-1.667z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardList);
export default __webpack_public_path__ + "static/media/clipboard-list.2a8b6fdd.svg";
export { ForwardRef as ReactComponent };